import React from "react";
import { HiDownload } from "react-icons/hi";
import resume from "../../../Resume-Md-Muntasir-Hossain.pdf";

const Banner = () => {
  return (
    <section>
      <div
        id="home"
        className="lg:h-[700px]
        md:h-[500px]
        h-[650px]
        grid  
        lg:grid-cols-2 
        md:grid-cols-2 
        grid-cols-1 
        justify-items-center 
        items-center 
        content-center 
        z-50  
        bg-gray-50 
        lg:px-20"
      >
        <div className="text-neutral lg:mb-14  md:ml-10 lg:text-left md:text-left text-center lg:order-1 md:order-1 order-2 lg:pt-0 md:pt-0 pt-6 px-6 lg:px-0 md:px-0">
          <p className="lg:mb-4 mb-[2.5px] lg:text-6xl md:text-3l text-2xl ">
            Hello! I'm
          </p>
          <h1 className="lg:mb-4 md:mb-2 mb-2 lg:text-8xl md:text-5xl tracking-wide text-4xl lg:ml-[-3.5px]">
            <span className="font-[500]">Muntasir</span>
          </h1>
          <p className=" lg:mb-12 md:mb-10 mb-7 lg:text-2xl md:text-lg text-md">
            Front-End Web Developer Specializing in React.js
          </p>
          <a href={resume} download="Resume-Md-Muntasir-Hossain.pdf">
            <button className="myBtn-outline lg:mx-0 md:mx-0 mx-auto rounded-full text-lg uppercase lg:mt-7 mt-4">
              <HiDownload className="lg:text-xl md:text-sm mr-1" />
              Download Resume
            </button>
          </a>
        </div>
        <div className="lg:order-2 sm:order-1">
          <img
            src="Images/hello.png"
            className="lg:w-[700px] md:w-[500px]"
            alt="hello"
          />
        </div>
      </div>
    </section>
  );
};

export default Banner;
